<template>
  <b-container fluid>
    <b-row class="page-heading">
      <b-col>
        <h1>Visibilité entrepôt par catégorie</h1>
        <p class="text-muted">
          Forcer l'entrepôt de préparation pour une catégorie de produit. La règle s'applique
          aussi aux sous-catégories. Laisser « Aucun » pour utiliser l'entrepôt de stockage.
        </p>
      </b-col>
    </b-row>

    <div v-if="isBusy" class="loader"></div>
    <b-row v-else>
      <b-col>
        <div class="ibox">
          <div class="ibox-content">
            <div class="filters">
              <div class="d-flex align-items-center">
                <div class="flex-grow-1 search-bar">
                  <b-form-group inline class="mb-0">
                    <b-input-group>
                      <label class="mb-0 align-self-center">
                        <i class="far fa-search fa-lg"></i>
                      </label>
                      <b-form-input v-model="filter" placeholder="Rechercher une catégorie" />
                      <b-input-group-append v-if="filter">
                        <b-button :disabled="!filter" @click="filter = ''">
                          <i class="far fa-times"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </div>
              </div>
            </div>
            <b-table class="mt-2" hover show-empty :items="filteredCategories" :fields="fields">
              <template slot="empty">
                <div class="text-center mt-2">Aucune catégorie ne correspond à la recherche</div>
              </template>
              <template slot="parent_name" slot-scope="data">
                {{ data.item.parent_name || "—" }}
              </template>
              <template slot="forced_warehouse" slot-scope="data">
                <b-form-select
                  :options="warehouseOptions"
                  :value="data.item.forced_warehouse ? data.item.forced_warehouse.id : null"
                  @change="(value) => saveForced(data.item, value)"
                ></b-form-select>
              </template>
            </b-table>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: "CategoryWarehouseList",
  data() {
    return {
      isBusy: false,
      filter: "",
      categories: [],
      fields: [
        { key: "name", label: "Catégorie" },
        { key: "parent_name", label: "Catégorie parente" },
        { key: "forced_warehouse", label: "Entrepôt forcé" },
      ],
    };
  },
  computed: {
    filteredCategories() {
      const search = this.filter.trim().toLowerCase();
      if (!search) {
        return this.categories;
      }
      return this.categories.filter((category) => {
        const haystack = [
          category.name,
          category.parent_name,
          category.forced_warehouse ? category.forced_warehouse.name : null,
        ];
        return haystack.some((value) => value && value.toLowerCase().indexOf(search) !== -1);
      });
    },
    warehouseOptions() {
      const options = [{ value: null, text: "— Aucun (entrepôt de stockage) —" }];
      (this.$store.getters["warehouse/getAll"] || []).forEach((w) => {
        options.push({ value: w.id, text: w.internal_code + " - " + w.name });
      });
      return options;
    },
  },
  mounted() {
    this.isBusy = true;
    Promise.all([
      this.$http.get(process.env.BACK_API_URL + "equipmentgroup/categories/warehouse"),
      this.$store.dispatch("warehouse/getAll", true),
    ])
      .then(([response]) => {
        this.categories = response.data.categories || [];
        this.isBusy = false;
      })
      .catch(() => {
        this.isBusy = false;
      });
  },
  methods: {
    saveForced(category, warehouseId) {
      this.$http
        .patch(
          process.env.BACK_API_URL + "equipmentgroup/" + category.id + "/forced-warehouse",
          null,
          { params: { warehouse_id: warehouseId || "" } }
        )
        .then(() => {
          const w = (this.$store.getters["warehouse/getAll"] || []).find((w) => w.id === warehouseId);
          category.forced_warehouse = warehouseId ? { id: warehouseId, name: w ? w.name : "" } : null;
          this.$toastr.success("Entrepôt de la catégorie « " + category.name + " » mis à jour.");
        })
        .catch(() => {
          this.$toastr.error("Échec de la mise à jour de la catégorie.");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/_variables.scss";

.filters {
  border: solid 1px $border-10p;
  padding: 6px 20px;
  .search-bar {
    color: $text-50p;
    input {
      border: none;
      @extend .clanprobook;
    }
    button.btn {
      color: inherit;
      background: none;
      border: none;
      padding: 0;
      height: 40px;
      width: 40px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CategoryWarehouse/CategoryWarehouseList.vue